import { cartSlice } from '../reducers/cart.reducers'

export const {
  billToAddressChangeAction,
  emptyCartAction,
  initCartAction,
  initCartValidationAction,
  orderFailure,
  orderSuccess,
  populateCartContentsAction,
  removeFromCartAction,
  shipToAddressChangeAction,
  totalValueChangeAction,
  updateCartFieldAction,
  updateCartStatus,
  updateCartWithValidation,
  updateProductQuantityAction,
} = cartSlice.actions
